export const KYC_STATUS = {
    APPROVED: 'approved',
    DECLINED: 'declined',
    NOT_STARTED: 'not_started',
    NOT_SUBMITTED: 'not_submitted',
    REVIEW: 'review',
    STARTED: 'started'
};
export const KYB_STATUS = {
    APPROVED: 'approved',
    DECLINED: 'declined',
    INCOMPLETE: 'incomplete',
    NOT_STARTED: 'not_started',
    NOT_SUBMITTED: 'not_submitted',
    REVIEW: 'review',
    STARTED: 'started'
};

export const deleted = [
    'Bank Service Charges',
    'Charitable Contributions',
    'Depreciation & Amortization',
    'Employee Salary',
    'Interest Expense',
    'Officer Salary',
    'Merchant Credit Card Fees',
    'Merchant Processing Fees'
];

export const CARD_TYPE = {
    PHYSICAL: 'physical',
    VIRTUAL: 'virtual'
};

export const TRANSFER_TYPE = {
    ACH: 'ach',
    INTRABANK: 'intrabank',
    CARD: 'card',
    DOMESTIC_WIRE: 'domesticWire'
};

export const TRANSFER_TYPE_MAP = {
    'ach-credit': 'ACH',
    'ach-debit': 'ACH',
    'intrabank-credit': 'Deposit',
    'intrabank-debit': '',
    'card-credit': '',
    'card-debit': '',
    'domesticWire-credit': 'Deposit',
    'domesticWire-debit': 'Deposit',
    'deposit-credit': 'Network Transfer',
    'deposit-debit': 'Network Transfer'
};

export const TRANSACTION_TYPE = {
    DEBIT: 'debit',
    CREDIT: 'credit'
};

export const MUI_CLOSE_MODAL_REASONS = ['backdropClick', 'escapeKeyDown'];

export const DEFAULT_TIMEZONE = 'America/Los_Angeles';

export const US_PHONE_NUMBER_REGEX = /^\(?([0-9]{3})\)?[-.\s]?([0-9]{3})[-.\s]?([0-9]{4})$/;
export const US_SSN_REGEX_TEST = new RegExp(/^(?!666|000)\d{3}-?(?!00)\d{2}-?(?!0{4})\d{4}$/);
export const US_SSN_REGEX = new RegExp(/^(?!666|000|9\d{2})\d{3}-?(?!00)\d{2}-?(?!0{4})\d{4}$/);
export const US_POSTAL_CODE_REGEX = new RegExp(/^[0-9]{5}(?:-[0-9]{4})?$/);
export const FIRST_LAST_NAME_REGEX = new RegExp(/^[a-zA-Z0-9\s]*$/);
export const EMAIL_REGEX = new RegExp(
    /@(?!hotmail|aol|live|outlook|gmail|yahoo|gmailer|ayahoo|onetel|protonmail|icloud)(([a-zA-Z\d-]+\.)+)/i
);

export const USER_ROLES = {
    CARD_HOLDER: 1,
    ADMIN: 2,
    SUPERADMIN: 3
};

export const REPLENISH_FRECUENCY = {
    ONE_TIME: 1,
    DAILY: 0
};

export const ENVIRONMENT = {
    DEVELOPMENT: 'development',
    PRODUCTION: 'production'
};

export const CARD_TRANSACTION_TYPE = {
    DECLINED: 'card.declined',
    REFUND: 'card.refund',
    REPLENISH: 'card.replenish',
    REVERSAL: 'card.reversal',
    SPEND: 'card.spend',
    SPEND_UPDATE: 'card.spend.update'
};

export const PAYSTAND_SUPPORT_URL = 'https://support.paystand.com/hc/en-us';
export const PAYSTAND_DASHBOARD_URL = 'https://dashboard.paystand.com/';
// For testing locally use Dashboard's local port
// export const PAYSTAND_DASHBOARD_URL = 'http://localhost:8081/';

export const PAYSTAND_FAQ_URL =
    'https://paystand.notion.site/paystand/DeFi-Corporate-Card-Product-FAQs-f1a83804ba96417e8e770a0d370b41c8';

export const GIFT_CARD_CATEGORY = 'Gift Card';

export const SMALL_DESKTOP = window.screen.width > 1023 && window.screen.width < 1440;

export const SOLIDFI_CARD_SHIPPING_STATUS = {
    PENDING: 'pending',
    SHIPPED: 'shipped',
    DELIVERED: 'delivered',
    RETURNED: 'returned',
    FAILURE: 'failure',
    CANCELED: 'canceled'
};

export const BUSINESS_MODEL_TYPE = {
    CREDIT_V1: 'Credit v1',
    DEPOSIT: 'Deposit',
    PIN: 'PIN',
    CREDIT_V2: 'Credit v2'
};

export const LOGIN_ERROR_TYPES = {
    NO_BUSINESS: 'PaystandNet/noBusinessFound',
    INVALID_TOKEN: 'PaystandNet/invalidAccessToken'
};

export const LOGIN_ERROR_MESSAGES = {
    no_business: 'This token expired, please try again.',
    invalid_token: 'We are unable to find the business you are trying to log in.'
};

export const SOLIDFI_CARD_STATUS = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    CANCELLED: 'cancelled',
    FROZEN: 'frozen',
    PENDING_ACTIVATION: 'pendingActivation'
};

export const SOLIDFI_CARD_DELIVERY_STATUS = {
    PENDING: 'pending',
    SHIPPED: 'shipped',
    DELIVERED: 'delivered',
    RETURNED: 'returned',
    FAILURE: 'failure',
    CANCELED: 'canceled'
};

export const NO_FUNDS_TITLE = {
    PREPAID_MODEL: 'Insufficient funds to add to cards',
    CREDIT_MODEL: "There isn't sufficient balance to create a card."
};
export const NO_FUNDS_TEXT = {
    PREPAID_MODEL: 'Please add money to your account to create a new card.',
    CREDIT_MODEL: 'Please cancel a card or reduce any card limit to create a new card.'
};

export const BUSINESS_FUNDING_TYPE = {
    CREDIT_LINE: 'credit_line',
    PREFUNDING: 'prefunding'
};

export const EULAS = {
    TERMS_AND_CONDITIONS: 'Terms and Conditions',
    E_SIGNATURE_AGREEMENT: 'E-Signature Agreement',
    END_USER_LEGAL_AGREEMENTS: 'End-User Legal Agreements'
};

export const DEFI_CARD_STATUS = {
    ACTIVE: 'active',
    FROZEN: 'frozen',
    CANCELED: 'canceled',
    ORDERED: 'ordered',
    SHIPPED: 'shipped',
    DELIVERED: 'delivered',
    REQUESTED: 'requested'
};

export const OWNERSHIP_DISCLOSURE_STATUS = {
    PENDING: 'pending',
    COMPLETED: 'completed'
};
